import React, { Component } from 'react';
import axios from 'axios';
import global from '../global';
import Select from 'react-select';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import { config } from '../../Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import EasyDividendLogo from '../../Asset/Images/easy-dividend-logo.png';
import DivPdf from '../../Asset/documents/Data Privacy Policy-BIL.pdf';

export class SendEmail extends Component {
    static displayName = SendEmail.name;

    constructor(props) {
        super(props);
        this.state = {
            companyList: [],
            companyID: -1,
            isSearchable: true,
            searchString: '',
            filesToBeSent: '',
            DPID: '',
            ShareholderName: '',
            PAN: '',
            Email: '',
            AssignmentName: '',
            AssignmentCode: -1,
            companyName: '',
            isOpen: false,
            isModalOpen: false,
            filePath: '',
            isBASF:'none',
            isChk:1
        };

        this.initialState = this.state;

        this.handleChange = this.handleChange.bind(this);
        this.handelFileChange = this.handelFileChange.bind(this);



    }

    closeModal = () => {
        this.setState({ isOpen: false })

        window.location.href = config.url.Web_URL + '/';
    };

    closeModalN = () => {
        this.setState({ isModalOpen: false })
    };

    componentDidMount() {
        debugger
        const AssignmentName = this.state.searchString;

        axios.get(global.UserManagement.GetAllCompaniesDDLAPI, AssignmentName)
            .then(response => {
                debugger
                if (response.data.status) {

                    const dpid = response.data.dpid;

                    const optionsCompany = response.data.data.map(d => ({
                        "value": d.ID,
                        "label": d.Label
                    }))
                    this.setState({
                        companyList: optionsCompany
                    })
                    this.setState({
                        DPID: dpid
                    })
                }
                else {

                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

    }

    handleCompany(e) {
        

        if (e.label == "BASF INDIA LIMITED") {
            this.setState({
                AssignmentCode: e.value,
                AssignmentName: e.label,
                isBASF: 'block',
                isChk: 0
            });
        }
        else {
            this.setState({
                AssignmentCode: e.value,
                AssignmentName: e.label,
                isBASF: 'none',
                isChk: 1
            });
        }

    }

    handleCheckBox(e) {
        const checked = e.target.checked;

        if (checked) {
            this.setState({
                isChk: 1
            });
        }
        else {
            this.setState({
                isChk: 0
            });
        }
    }

    handelFileChange = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;
        let form = new FormData();
        var mimeType = filesArray.type;

        form.append("File", filesArray);
        form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ filesToBeSent: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

    };
    handleAccept = (e) => {
        e.preventDefault();

        let form = new FormData();
        var filesArray = this.state.filesToBeSent;

        form.append("File", filesArray);
        form.append("AssignmentName", this.state.AssignmentName);
        form.append("AssignmentCode", this.state.AssignmentCode);
        form.append("PAN", this.state.PAN);
        form.append("Email", this.state.Email);
        form.append("ShareholderName", this.state.ShareholderName);
        form.append("DPID", this.state.DPID);

        const objSend = this.state;
        axios.post(global.UserManagement.SendDeclarationMailAPI, form,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
            .then(response => {
                debugger
                if (response.data.status) {
                    this.setState({ isOpen: true, isModalOpen: false });
                }
                else {
                    this.showNoti("Notification", response.data.message, "danger");
                    return;
                }
            })
            .catch(error => {
                console.log(error);
                this.showNoti("Notification", error, "danger");
            });
    }

    handleSend = (e) => {
        e.preventDefault();

        if (this.state.ShareholderName == "" || this.state.ShareholderName == null) {
            this.showNoti("Notification", "Shareholder Name is mandatory.", "warning");
            return;
        }

        if (this.state.DPID == "" || this.state.DPID == null) {
            this.showNoti("Notification", "DP ID/Folio ID is mandatory.", "warning");
            return;
        }

        if (this.state.PAN == "" || this.state.PAN == null) {
            this.showNoti("Notification", "PAN is mandatory.", "warning");
            return;
        }
        if (this.state.PAN !== "") {
            var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

            if (!regex.test(this.state.PAN.toUpperCase())) {
                this.showNoti("Notification", "Invalid PAN.", "danger");
                return;
            }

        }
        if (this.state.Email == "" || this.state.Email == null) {
            this.showNoti("Notification", "Email is mandatory.", "warning");
            return;
        }
        if (this.state.AssignmentCode == -1 || this.state.AssignmentCode == "" || this.state.AssignmentCode == null) {
            this.showNoti("Notification", "Listed Company Name is mandatory.", "warning");
            return;
        }

        if (this.state.filesToBeSent == "") {
            this.showNoti("Notification", "Declaration Proof is not chosen.", "warning");
            return;
        }

        if (this.state.filesToBeSent.size > 3145728) //3145728
        {
            this.showNoti("Notification", "File size cannot exceed more than 100 KB", "danger");
            return;
        }

        if (this.state.Email !== "") {
            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (!regex.test(this.state.Email)) {
                this.showNoti("Notification", "Invalid Email Address.", "danger");
                return;
            }
        }

        if (this.state.AssignmentName == "BASF INDIA LIMITED") {
            this.setState({ isModalOpen: true });
            return;
        }
        else {
            let form = new FormData();
            var filesArray = this.state.filesToBeSent;

            form.append("File", filesArray);
            form.append("AssignmentName", this.state.AssignmentName);
            form.append("AssignmentCode", this.state.AssignmentCode);
            form.append("PAN", this.state.PAN);
            form.append("Email", this.state.Email);
            form.append("ShareholderName", this.state.ShareholderName);
            form.append("DPID", this.state.DPID);

            const objSend = this.state;
            axios.post(global.UserManagement.SendDeclarationMailAPI, form,
                { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    debugger
                    if (response.data.status) {
                        this.setState({ isOpen: true, isModalOpen: false });
                    }
                    else {
                        this.showNoti("Notification", response.data.message, "danger");
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.showNoti("Notification", error, "danger");
                });
        }

      
    }

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL + `/Resident`;
    }

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    render() {
        const {
            isSearchable
        } = this.state;

        return (
            <div>
                <ReactNotification />

                <div className="limiter">
                    <div className="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">
                        <img src={EasyDividendLogo} alt="Logo" className="logo-img" />
                            <div className="wrap-login100 m-t-20">
                                <div className="login100-form">
                                <h3 className="legend last docTitle">Declaration by Email</h3> 
                                <Row className="w-100 dec_form">
                                    <Col md={12}>
                                        <label className="required-field m-t-20">Shareholder Name as per Trading Account</label>
                                        <FormControl type="text" name="ShareholderName" key="txtShareholderName" className="m-t-10" maxLength="100"
                                            value={this.state.ShareholderName}
                                            onChange={this.handleChange}
                                            placeholder="Max 100 Characters"
                                            maxLength="100"
                                        />
                                    </Col>
                                    <Col md={6} className="m-t-20">
                                        <label className="required-field">DP ID/Folio ID</label>
                                        <FormControl disabled type="text" name="DPID" key="txtDPID" className="m-t-10" maxLength="100"
                                            value={this.state.DPID}
                                            //onChange={this.handleChange}
                                            //placeholder="Max 16 Characters"
                                            //maxLength="16"
                                        />
                                    </Col>
                                    <Col md={6} className="m-t-20">
                                        <label className="required-field">PAN</label>
                                        <FormControl type="text" name="PAN" key="txtPAN" className="m-t-10" maxLength="100"
                                            value={this.state.PAN}
                                            onChange={this.handleChange}
                                            placeholder="Max 10 Characters"
                                            maxLength="10"
                                        />
                                    </Col>
                                    <Col md={12} className="m-t-20">
                                        <label className="required-field">Email</label>
                                        <FormControl type="text" name="Email" key="txtEmail" className="m-t-10" maxLength="100"
                                            value={this.state.Email}
                                            onChange={this.handleChange}
                                            placeholder="Max 100 Characters"
                                            maxLength="100"
                                        />
                                    </Col>
                                    <Col md={12} className="m-t-20">
                                        <label className="required-field">Listed Company Name</label>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select Company"
                                            placeholder="Select Company"
                                            isSearchable={isSearchable}
                                            options={this.state.companyList}
                                            value={this.state.companyList.find(obj => obj.value === this.state.AssignmentCode)}
                                            onChange={this.handleCompany.bind(this)}
                                        />
                                    </Col>



                                    <Col md={12} className="m-t-20">
                                        <label className="required-field" htmlFor="file">Declaration Proof</label>
                                        <br />
                                        <input type="file" name="files" id="fileUpd" onChange={this.handelFileChange} className="m-t-20" />
                                        <br />
                                            <label className="m-t-10 labelNote">Note: Only .pdf, .doc, .docx, .jpg, .png & .msg file format are allowed and max size is 3 MB</label>
                                    </Col>

                                    <Col md={12} className="m-t-20 labelNote" style={{ display: this.state.isBASF }}>
                                        <input type="checkbox" name="myCheckbox" value={this.state.isChk} onChange={this.handleCheckBox.bind(this)}  /> I hereby give my consent for use of these documents/information for carrying out withholding tax compliances by BASF Limited and/or its consultants
                                    </Col>

                                    <Col md={12} className="m-t-20">
                                            <button className="btn btn-primary w-100" onClick={this.handleSend.bind(this)} disabled={!this.state.isChk}>
                                            Send Declaration
                                        </button>
                                    </Col>
                                </Row>
                                     
                                    <img src={goBack} className="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />

                                    

                            </div>


                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={this.state.isModalOpen} onHide={this.closeModalN}>
                    <Modal.Header closeButton>
                        <Modal.Title className="modal_title">Data Privacy Policy</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_body">
                        <iframe src={DivPdf} height={"350"} width={"100%"} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-primary float-right m-r-10 m-b-10" variant="primary" onClick={this.handleAccept}>
                            I Accept
                        </Button>

                        <Button variant="dark" onClick={this.closeModalN}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>
                <Row>
                    <Modal show={this.state.isOpen} onHide={this.closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title className="modal_title">Notification !</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="modal_body">
                            Declaration has been sent successfully
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="dark" onClick={this.closeModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </Row>

                {/*<h1>SEND EMAIL PAGE</h1>*/}


            </div>
        );
    }
}